import higherOrderSaga from 'Stores/hos';
import { myOrdersSliceActions } from 'Stores/my-orders/index';
import CargoDirectServiceV1 from 'Services/v1/cargo-direct';

export default [
	higherOrderSaga.createFetchedSaga(myOrdersSliceActions.ordersAction, CargoDirectServiceV1.getMyOrders.bind(CargoDirectServiceV1)),
	higherOrderSaga.createFetchedSaga(myOrdersSliceActions.orderDetailAction, CargoDirectServiceV1.getOrderDetail.bind(CargoDirectServiceV1))
];